export enum MetricBulkUploadParent {
  EXTERNAL = 'external',
  PORTFOLIO_PERFORMANCE = 'pp',
}
